// extracted by mini-css-extract-plugin
module.exports = {"root":"Location_root__QacAe","page":"Location_page__Nu_zA","description":"Location_description__yiWoe","h4":"Location_h4__5k150"};